import { MunicipalityListVM } from 'civil-status/view-models/research-municipality';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<MunicipalityListVM, keyof MunicipalityListVM>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'idAnsc',
    label: 'ID Comune ANPR',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'startValidityDate',
    label: 'Data inizio validità',
  },
  {
    id: 'endValidityDate',
    label: 'Data fine validità',
  },
  {
    id: 'orderNumber',
    label: 'N. ordinamento',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
